import React from 'react'
import ScrollToTop from '../components/ScrollToTop'
import { Helmet } from 'react-helmet';

function PrivacyPolicy() {
  return (

    <>
      <ScrollToTop />

      <Helmet>
        <title>Политика за приватност | Онлајн продавница за авто делови</title>
        <meta name="description" content="Прочитајте како ја третираме вашата приватност, кои информации ги собираме и како ги заштитуваме вашите лични податоци на нашата онлајн продавница." />
        <meta name="keywords" content="политика за приватност, лични податоци, заштита на податоци, приватност, онлајн продавница, авто делови, моторни масла" />
      </Helmet>

      <div className='w-full flex justify-center py-16 bg-gray-50 mt-6 '>
        <div className='mx-auto max-w-[800px] px-6 '>
          <h1 className='text-4xl font-semibold text-center'>Политика на приватност</h1>
          <p className='text-l mt-6  leading-relaxed'>
            Дел од нашата деловна активност меѓудругото е и собирање и обработка на вашите лични податоци. Malservis.mk се обврзува да ја заштити приватноста на податоците и потврдува дека со нив ќе постапува во согласност со Законот за заштита на личните податоци и други позитивни прописи од оваа област кои се на сила во Република Македонија.
          </p>
          <p className='text-l mt-6  leading-relaxed'>
            Во рамките на оваа Политика на приватност Ви даваме информации за тоа кои лични податоци ги собираме и како ги обработуваме истите при користење на нашите услуги, а тоа го правиме согласно Законот за заштита на лични податоци.
          </p>
          <p className='text-l mt-6  leading-relaxed underline'>
            Кои податоци ги собираме?
          </p>
          <p className='text-l mt-6  leading-relaxed'>
            Ги собираме исклучиво само оние податоци кои се неопходни за извршување на нашата деловна активност односно, процесирање и извршување на вашите нарачки. Овие податоци вклучуваат:
          </p>

          <ul className='list-inside list-disc text-l mt-6  leading-relaxed'>
            <li>
              лични податоци на купувачот: име, презиме, адреса за испорака, емаил адреса, телефонски број.
            </li>
            <li>
              колачиња (cookies): Колачињата не содржат лични или приватни податоци за вас, но можат да соберат информации за вашите навики на пребарување. Cookies не можат да бидат искористени да стартуваат програм или да пренесат вирус до вашиот компјутер. Тие се мали текстуални датотеки кои се поставуваат на вашиот компјутер или мобилен уред кога ќе ја посетите нашата веб-страница. Информациите кои ги обезбедуваат се користат за да го подобрат вашето искуство на нашата страница преку подобрување на нејзината функционалност и перформанси и запамтување на вашите преференци при повторни посети. Покрај тоа, постојат и колачиња кои служат за рекламирање, и истите се користат за да ви прикажат реклами согласно вашите интереси. Со користење на нашата страна може да се согласите за користење на колачиња, меѓутоа во секое време имате право да ја промените својата одлука, да избришете или одбиете колачиња преку подесувањата на вашиот прелистувач. Исто така, можете да ги избришете сите колачиња од вашиот уред, но земете во предвид дека ова можеби ќе влијае на функционалноста на нашиот веб сајт.
            </li>
          </ul>
          <p className='text-l mt-6  leading-relaxed underline'>
            Како ги користиме вашите податоци?
          </p>
          <p className='text-l mt-6  leading-relaxed'>
            Вашите податоци ги користиме исклучиво за целта за која се собрани односно обработка на вашите нарачки и реализација на истите, комуникација со Вас со цел потврда на нарачката и информирање за статусот на истата, навремена и точна испорака. Доколку се согласите вашите податоци може да ги користиме и за испраќање на промоции, попусти или новости во врска со нашите производи. Податоците собрани од колачињата ги користиме за подобрување на Вашето корисничко искуство.
          </p>
          <p className='text-l mt-6  leading-relaxed underline'>
            Споделување на податоци
          </p>
          <p className='text-l mt-6  leading-relaxed'>
            Сите податоци за купувачите/корисниците се чуваат и се достапни строго само на вработените на кои им се неопходни за исполнување на редовните работни активности. Се обврзуваме дека Вашите лични податоци нема да бидат споделени со трети лица, освен кога тоа е потребно за реализација на вашите нарачки како што е во случај на споделување на податоците до:
          </p>
          <ul className='list-inside list-disc text-l mt-6  leading-relaxed'>
            <li>
              Логистички компании: Вашите податоци може да бидат споделени со курирски компании за испорака на Вашата нарачка и за остварување на вашите законски права (право на повлекување од договорот и враќање на производот, остварување на права врз основа на прифатен приговор и сл.).
            </li>
            <li>
              Законски обврски: Во случај на законска обврска, можеме да ги споделиме вашите податоци со надлежни органи.
            </li>
          </ul>
          <p className='text-l mt-6  leading-relaxed underline'>
            Како ги чуваме вашите податоци?
          </p>
          <p className='text-l mt-6  leading-relaxed'>
            Ние ги преземаме сите неопходни технички и организациски мерки за заштита на вашите лични податоци и за обезбедување на највисоко ниво на тајност и заштита при обработката на личните податоци со кои располагаме.
          </p>
          <p className='text-l mt-6  leading-relaxed underline'>
            Вашите права во однос на обработката на лични податоци
          </p>
          <p className='text-l mt-6  leading-relaxed'>
            Како субјект на лични податоци, во секое време имате право да:
          </p>
          <ul className='list-inside list-disc text-l mt-6  leading-relaxed'>
            <li>
              Барате пристап до вашите лични податоци.
            </li>
            <li>
              Барате корекција на неточни податоци.
            </li>
            <li>
              Барате бришење на вашите податоци.
            </li>
            <li>
              Ограничите обработка на вашите податоци.
            </li>
            <li>
              Прифатите или одбиете примање на маркетинг пораки.
            </li>
          </ul>
          <p className='text-l mt-6  leading-relaxed'>
            За да ги остварите овие права, контактирајте нè преку е-маил: info@malservis.mk
          </p>
          <p className='text-l mt-6  leading-relaxed underline'>
            Прифаќање на условите
          </p>
          <p className='text-l mt-6  leading-relaxed'>
            Со пристапување и/или користење на веб страницата на malservis.mk и нашите услуги, Вие изјавувате дека сте се запознале и во потполност сте ги разбрале и прифатиле одредбите од оваа Политика за приватност и Правилата и условите за користење, вклучително и нивните последователни промени и сте одговорни повремено да ја проверувате нивната содржина. Покрај тоа, давате изречна согласност за обработка на Вашите лични податоци од страна на malservis.mk, за целите за кои ги доставувате.
          </p>
          <p className='text-l mt-6  leading-relaxed'>
            Доколку не се согласувате со оваа Политика за приватност и/или со Правилата и условите за користење, би Ве замолиле да не пристапувате и да не ја користите нашата веб страница.
          </p>
          <p className='text-l mt-6  leading-relaxed underline'>
            Промени на Политиката на Приватност
          </p>
          <p className='text-l mt-6  leading-relaxed'>
            malservis.mk го задржува правото да врши измени и дополнувања на оваа Политика за приватност, за кои измени и дополнувања ќе биде поставено извесување на овој веб сајт. Ви препорачуваме редовно да ја проверувате.
          </p>
          <p className='text-l mt-6  leading-relaxed underline'>
            Контакт
          </p>
          <p className='text-l mt-6  leading-relaxed'>
            Ако имате било какви прашања или барања во врска со вашите лични податоци, ве молиме контактирајте нè на:
          </p>
          <ul className='list-inside list-disc text-l mt-6  leading-relaxed'>
            <li>
              Е-маил: contact@malservis.mk
            </li>
            <li>
              Телефон: 074/229-595
            </li>
          </ul>
        </div>
      </div>
    </>

  )
}

export default PrivacyPolicy
